"use client";
import { useReducer, ReactNode, useContext, useEffect, useState } from "react";
import {
  ModalStateContext,
  ModalDispatchContext,
  GlobalStateContext,
} from "./context";
import {
  ModalState,
  ModalDispatch,
  xGlobalModal,
  BannerData,
  BannerList,
} from "./types";
import { modalReducer } from "./reducer";
import { getBannersForToday, isUserSignedIn } from "src/utils/generalUtils";
import { deviceId } from "src/network/deviceId";
import { getAbConfigData } from "src/network/services/abconfig.service";
import { getUserDetails } from "src/network/services/common";
import { IAccountDetailsResponse } from "app/bus/type";
import { getofferJson } from "api/home";
import { usePathname } from "next/navigation";

// import dummyResponse from "./dummyResponse.json";
export const ModalProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [abResponse, setABreponse] = useState({});
  const [bannerData, setBannerData] = useState<
    BannerList | Record<string, unknown>
  >({});

  const [userDetails, setUserDetails] = useState<
    IAccountDetailsResponse | undefined
  >(undefined);

  const [state, dispatch] = useReducer(modalReducer, {
    modalName: "",
    isShowing: false,
    actionType: "",
  });
  let isLoggedIn = false;

  if (typeof window !== "undefined") {
    isLoggedIn = isUserSignedIn();
  }

  const pathname = usePathname();

  const fetchHomePageBanners = async () => {
    if (pathname === "/bus")
      try {
        const response = (await getofferJson()) as { data: BannerData[] };
        if (response?.data) {
          // const response = { data: dummyResponse };
          const bannerList = getBannersForToday(response.data);
          setBannerData(bannerList);
        }
      } catch (e) {
        console.info(e);
      }
  };

  const fetchAbTestData = async () => {
    try {
      const response = (await getAbConfigData()) || {};
      setABreponse({ ...response });
    } catch (e) {
      console.error(e);
    }
  };

  const fetchUserDetails = async () => {
    try {
      const response =
        ((await getUserDetails()) as IAccountDetailsResponse) || {};
      setUserDetails(response);
    } catch (e) {
      return {};
    }
  };

  useEffect(() => {
    if (pathname === "/bus") fetchHomePageBanners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_CT_ENV !== "development") {
      deviceId();
    }
    fetchAbTestData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isUserSignedIn()) fetchUserDetails();
  }, [isLoggedIn]);

  const globalValues = {
    isSignedIn: isLoggedIn,
    abData: abResponse,
    userDetails,
    bannerData,
  };
  const value = {
    modalName: state?.modalName || "",
    isShowing: state?.isShowing || false,
    actionType: state?.actionType || "",
  };

  return (
    <ModalStateContext.Provider value={value}>
      <GlobalStateContext.Provider value={globalValues}>
        <ModalDispatchContext.Provider value={dispatch}>
          {children}
        </ModalDispatchContext.Provider>
      </GlobalStateContext.Provider>
    </ModalStateContext.Provider>
  );
};

export const useModalState = (): ModalState => {
  const context = useContext(ModalStateContext);
  if (context === undefined) {
    throw new Error("useModalState must be used within a ModalProvider");
  }
  return context;
};
export const useGlobalState = (): xGlobalModal => {
  const context = useContext(GlobalStateContext);
  if (context === undefined) {
    throw new Error("useGlobalState must be used within a ModalProvider");
  }
  return context;
};

export const useModalDispatch = (): ModalDispatch => {
  const context = useContext(ModalDispatchContext);
  if (context === undefined) {
    throw new Error("useModalDispatch must be used within a ModalProvider");
  }
  return context;
};
